<template>
  <div>
    <spinner v-if="loading"></spinner>

    <div v-else>
      <div>
        <h1 class="text-2xl font-bold text-center text-primary">
          ผลการประเมินด้านพฤติกรรมสร้างเสริมสุขภาพ
        </h1>
        <h1 class="text-xl font-light text-center">
          Health Promotion Lifestyle Profile: Healthy CMU’Version (HPLP)
        </h1>
      </div>

      <div class="card">
        <h1 class="text-lg font-bold text-center">
          โดยการเกณฑ์การแบ่งระดับพฤติกรรมสร้างเสริมสุขภาพ
          แยกออกเป็นองค์ประกอบต่างๆได้ดังนี้
        </h1>
        <table class="w-full mt-6 shadow-sm">
          <thead>
            <tr>
              <th
                class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left uppercase border-b border-gray-200 bg-gray-50 text-gray-26"
              >
                องค์ประกอบ
              </th>
              <th
                class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left uppercase border-b border-gray-200 bg-gray-50 text-gray-26"
              >
                อยู่ในเกณฑ์ปรับปรุง
              </th>
              <th
                class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left uppercase border-b border-gray-200 bg-gray-50 text-gray-26"
              >
                อยู่ในเกณฑ์พอใช้
              </th>

              <th
                class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left uppercase border-b border-gray-200 bg-gray-50 text-gray-26"
              >
                อยู่ในเกณฑ์ดี
              </th>
              <th
                class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left uppercase border-b border-gray-200 bg-gray-50 text-gray-26"
              >
                อยู่ในเกณฑ์ดีมาก
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-gray-50">
              <td
                class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                วิถีการดำเนินชีวิตโดยรวม
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                0.00 - 1.00
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                1.00 - 1.99
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                2.00 - 2.99
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                3.00 - 4.00
              </td>
            </tr>

            <tr class="bg-gray-50">
              <td
                class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                รวม (คน)
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.low.count }}
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.fair.count }}
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.good.count }}
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.veryGood.count }}
              </td>
            </tr>

            <tr class="bg-gray-50">
              <td
                class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
              >
                ร้อยละ
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.low.ratio }}
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.fair.ratio }}
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.good.ratio }}
              </td>
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
              >
                {{ group.result.veryGood.ratio }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card">
        <h1 class="text-xl text-center">แบ่งตามคณะ</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ group.group.faculty.total_count }} คน
        </p>

        <x-bar-sd-chart
          class="bar-chart"
          :labels="group.group.faculty.labels"
          :averages="group.group.faculty.averages"
          :universityAverage="group.total_average"
          :sds="group.group.faculty.sd"
          :yMax="5"
        />
      </div>
      <div class="card">
        <h1 class="text-xl text-center">แบ่งตามประเภทพนักงาน</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ group.group.employee_type.total_count }} คน
        </p>

        <x-bar-sd-chart
          class="bar-chart"
          :labels="group.group.employee_type.labels"
          :averages="group.group.employee_type.averages"
          :universityAverage="group.total_average"
          :sds="group.group.employee_type.sd"
          :yMax="5"
        />
      </div>
      <div class="card">
        <h1 class="text-xl text-center">แบ่งตามเพศ</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร {{ group.group.gender.total_count }} คน
        </p>

        <x-bar-sd-chart
          class="bar-chart"
          :labels="group.group.gender.labels"
          :averages="group.group.gender.averages"
          :universityAverage="group.total_average"
          :sds="group.group.gender.sd"
          :yMax="5"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "./charts/BarChart";
import UniversityAverageSdStackedBarChart from "./charts/UniversityAverageSdStackedBarChart";
import { Tabs, Tab } from "vue-slim-tabs";
import axios from "axios";
import Spinner from "@/components/loading/Spinner";
import EventBus from "@/events/event-bus.js";

export default {
  name: "hplp-dashboard",
  components: {
    BarChart,
    "x-bar-sd-chart": UniversityAverageSdStackedBarChart,
    Tabs,
    Tab,
    Spinner,
  },
  created() {
    this.fetchGroup();

    EventBus.$on("dashboardYearChanged", this.fetchGroup);
    EventBus.$on("dashboardEmployeeTypeChanged", this.fetchGroup);
  },
  beforeDestroy() {
    EventBus.$off("dashboardYearChanged", this.fetchGroup);
    EventBus.$off("dashboardEmployeeTypeChanged", this.fetchGroup);
  },
  data() {
    return {
      group: {},
      loading: true,
    };
  },
  methods: {
    async fetchGroup() {
      this.loading = true;
      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/dashboard/hplp/group?year=${this.$store.state.dashboardYear}&employeeType=${this.$store.state.dashboardEmployeeType}`,
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.group = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style src="vue-slim-tabs/themes/default.css"></style>
